import { getDoc, doc } from "firebase/firestore"; 
import { db } from "../../firebase/firebase";
import { isApprovedTeacher } from "../../utils/teacherStatus";

export const fetchTeacherInfo = async (teacherID) => {
  try {
    const teacherDocRef = doc(db, "teachers", teacherID); 
    const teacherDoc = await getDoc(teacherDocRef);
    if (teacherDoc.exists() && isApprovedTeacher(teacherDoc.data())) {
      const teacherData = teacherDoc.data();
      return {
        name: `${teacherData.firstName} ${teacherData.lastName}`,
        email: teacherData.email
      } 
    } else {
      console.error("No such teacher found!");
      return "Unknown Tutor";
    }
  } catch (error) {
    console.error("Error fetching teacher details:", error);
    return "Error";
  }
};

